import classNames from 'classnames'

import { Button, Modal } from '@/shared'

import style from './ConfirmRemoveModal.module.scss'

interface IProps {
    login: string | null
    onClose: () => void
    onRemoveAdmin: (adminId: string) => void
}

export const ConfirmRemoveModal = (props: IProps) => {
    const { onClose, login, onRemoveAdmin } = props

    const actions = [
        {
            title: 'Да',
            callback: () => {
                if (login) {
                    onRemoveAdmin(login)
                    onClose()
                }
            },
            className: 'yes'
        },
        {
            title: 'Нет',
            callback: onClose,
            className: 'no'
        }
    ]

    return (
        <Modal show={!!login}>
            <div className={style.container}>
                <div className={style.title}>
                    <span>Вы действительно хотите удалить администратора {login} ?</span>
                </div>
                <div className={style.actions}>
                    {actions.map((action) => {
                        const { title, callback, className } = action
                        return (
                            <Button key={title} className={classNames(style.btn, style[className])} onClick={callback}>
                                {title}
                            </Button>
                        )
                    })}
                </div>
            </div>
        </Modal>
    )
}
